export default "__VITE_ASSET__BzIC5L8Q__"